// extracted by mini-css-extract-plugin
export default {"productGallery":"VI-z","inQuickShop":"WI-z"};